import styled from 'styled-components';
import {
  ButtonGroup,
  PrimaryButton,
  SecondaryButton,
  GhostButton,
} from '@ardoq/button';
import { colors, s16 } from '@ardoq/design-tokens';
import { type I18nLocale, t } from '@ardoq/i18n';

const FooterContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  background: ${colors.white950};
  padding: ${s16};
`;

type PerspectivesFooterProperties = {
  onClear: VoidFunction;
  onClose?: VoidFunction;
  onApply: VoidFunction;
  i18nLocale?: I18nLocale;
};
const PerspectivesFooter = ({
  onClear,
  onClose,
  onApply,
  i18nLocale = {},
}: PerspectivesFooterProperties) => (
  <FooterContainer>
    <ButtonGroup>
      <GhostButton data-test-id="perspectives-clear-button" onClick={onClear}>
        {t(i18nLocale, 'perspectivesSidebar:footer.clear', 'Clear')}
      </GhostButton>
      <SecondaryButton
        data-test-id="perspectives-cancel-button"
        onClick={onClose}
      >
        {t(i18nLocale, 'perspectivesSidebar:footer.close', 'Close')}
      </SecondaryButton>
      <PrimaryButton data-test-id="perspectives-apply-button" onClick={onApply}>
        {t(i18nLocale, 'perspectivesSidebar:footer.apply', 'Apply')}
      </PrimaryButton>
    </ButtonGroup>
  </FooterContainer>
);

export { PerspectivesFooter };
